import moment from 'moment';

import './date-range-picker.style.sass';
import template from './date-range-picker.tpl.pug';

class DateRangePickerController {
    /* @ngInject */
    constructor() {
        this.isStartDateSelection = true;
    }

    $onChanges(changeObject) {
        if (changeObject.start) {
            let start = moment(this.start);

            this.start = start.isValid()
                ? start.startOf('day').valueOf()
                : moment().startOf('day').valueOf();

            this.startView = moment(this.start);
        }
        if (changeObject.start || changeObject.end) {
            let end = moment(this.end);

            this.end = end.isValid()
                ? end.startOf('day').valueOf()
                : moment().startOf('day').valueOf();

            this.endView = moment(this.end).diff(this.startView, 'month', true) < 1
                ? moment(this.startView).add(1, 'month').valueOf()
                : this.end.valueOf();

            this.viewDifference = this.getDifferenceInMonths(this.startView, this.endView);
        }
    }

    isAnotherMonth(source, timestamp) {
        return moment(source).month() !== moment(timestamp).month();
    }

    isBetweenInterval(timestamp) {
        return moment(this.start).valueOf() <= timestamp && timestamp <= moment(this.end).valueOf();
    }

    checkDayActive(timestamp) {
        return moment(this.start).valueOf() === timestamp || moment(this.end).valueOf() === timestamp;
    }

    // using moment instance instead of timestamp so the underlying
    // date-picker components get updated every time we change the
    // start or end dates
    update(timestamp) {
        if (this.isStartDateSelection) {
            this.start = moment(timestamp);
            this.end = moment(this.start);
        } else {
            let end = this.start < timestamp
                ? timestamp
                : this.start;

            let start = this.start > timestamp
                ? timestamp
                : this.start;

            this.start = moment(start);
            this.end = moment(end);

            this.onChange({
                start: this.start.valueOf(),
                end: this.end.valueOf()
            });
        }

        this.isStartDateSelection = !this.isStartDateSelection;
    }

    startViewChanged(timestamp) {
        this.startView = moment(timestamp).valueOf();

        if (this.isDifferenceLessThan1Month(this.startView, this.endView)) {
            this.endView = moment(this.startView).add(1, 'month').valueOf();
        }

        this.viewDifference = this.getDifferenceInMonths(this.startView, this.endView);
    }

    endViewChanged(timestamp) {
        this.endView = moment(timestamp).valueOf();

        if (this.isDifferenceLessThan1Month(this.startView, this.endView)) {
            this.startView = moment(this.endView).subtract(1, 'month').valueOf();
        }

        this.viewDifference = this.getDifferenceInMonths(this.startView, this.endView);
    }

    getDifferenceInMonths(start, end) {
        return moment(end).diff(start, 'month', true);
    }

    isDifferenceLessThan1Month(start, end) {
        return this.getDifferenceInMonths(start, end) < 1;
    }
}

export default {
    selector: 'dbADateRangePicker',
    template: template(),
    controller: DateRangePickerController,
    bindings: {
        start: '<',
        end: '<',
        startOfWeek: '<',
        onChange: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/date-range-picker/date-range-picker.cmpt.js